module.exports = "/_next/static/videos/step2-028cd405c8eec2aaa32bcbfb123ec595.mp4";